const backendUrl = 'https://nelson-dashboard.telekom.net'

module.exports = {
   backendUrl
}
